import React from 'react';
import { composeClassName } from '@/utils/util_helpers';
import { BadgeProps } from './types';

const Badge2: React.FC<BadgeProps> = ({
  badgeVariant,
  badgeSize,
  badgeStyle,
  leadingIcon,
  trailingIcon,
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={composeClassName(
        'badge2',
        `badge2-${badgeSize}`,
        `badge2-${badgeStyle}`,
        badgeStyle !== 'gradient' && `badge2-${badgeVariant}`,
        className && className,
      )}
      {...props}
    >
      {React.isValidElement(leadingIcon) && leadingIcon}
      {children && <span className="badge2-content">{children}</span>}
      {React.isValidElement(trailingIcon) && trailingIcon}
    </div>
  );
};

export { Badge2 };
